import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import Informacoes from '@/views/escritorios/Informacoes'
import AbaEndereco from '@/views/escritorios/AbaEndereco'
import Contato from '@/views/escritorios/Contato'
import Datefield from '@/components/layout/datefield/Datefield.vue'
import Timefield from '@/components/layout/timefield/Timefield.vue'
import { BToast, BSpinner } from 'bootstrap-vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import mensagens from '@/util/mensagens'
import mascaras from '@/util/mascaras'
import util from '@/util'
import cnpj from '@/util/cnpj'
import cpf from '@/util/cpf'
import cadastroUtil from '@/util/cadastroUtil'
import { valorEhCpf, valorEhCnpj } from '@/util/index'

export default {
  name: 'cadastro-escritorio',
  components: {
    cabecalho,
    menuLateral,
    Datefield,
    Timefield,
    AbaEndereco,
    Contato,
    Informacoes,
    'b-toast': BToast,
    'b-spinner': BSpinner
  },

  computed: {
    ...mapState('escritorios', ['formulario', 'dadosRetorno', 'flagsDeControle', 'listaUsuariosRepresentanteLegal']),
    ...mapGetters('escritorios', ['ehEmpresaOffice']),

    desabilitarCampos () {
      return this.flagsDeControle.manipulandoDados.status || this.flagsDeControle.carregandoDados.status
    },
    ehPessoaFisica () {
      return this.formulario.tipo === 1
    },
    tabelaConsumoSemRegistros () {
      return this.listaConsumos.length === 0
    },
    tabelaRecursoSemRegistros () {
      return this.listaRecursos.length === 0
    }
  },

  data: () => {
    return {
      imagem_logotipo: null,
      flagAbas: {
        informacoes: false,
        endereco: false,
        contato: false
      }
    }
  },

  mounted () {
    this.ActionResetarDadosRetornoCadastro()
    this.ActionResetarDadosFormularioEscritorio()
    this.limparCampos()
    this.formulario.informacoes.status = 1
  },

  methods: {
    ...mapActions('escritorios', [
      'ActionResetarDadosFormularioEscritorio',
      'ActionSalvarEscritorio',
      'ActionObterEscritorio',
      'ActionResetarDadosRetornoCadastro',
      'ActionResetarDadosPessoaisFormularioEscritorio',
      'ActionResetarDadosEmpresariaisFormularioEscritorio'
    ]),
    ...mapActions('auth', ['ActionSetLogoCliente']),

    async buscarInformacoesDoCnpj (cnpj) {
      try {
        const retorno = await this.axios.get(`/consultar/cnpj/${cnpj}`)
        return retorno.data
      } catch (e) {
        console.log(e)
        return null
      }
    },

    async salvarRegistro () {
      const validacaoOk = this.validarDadosFormulario()
      if (validacaoOk) {
        await this.executarSalvarRegistro()
      } else {
        this.obterAbaDoComErro()
      }
    },
    async obterEscritorio (id) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        await this.ActionObterEscritorio(id)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    obterDadosFormularioInformacoesAdicionais () {
      if (this.ehPessoaFisica) {
        return util.mapearObjetos(this.formulario.informacoes.pessoais, {})
      }

      return util.mapearObjetos(this.formulario.informacoes.empresariais, {})
    },

    validarDadosFormulario () {
      this.ActionResetarDadosRetornoCadastro()
      const formulario = this.tratarDadosFormulario()
      if (util.valorVazio(formulario.cpf_cnpj)) {
        this.dadosRetorno.listaDeErros['cpf_cnpj'] = 'Este campo é obrigatório'
      }

      if (util.valorVazio(formulario.codigo_empresa)) {
        this.dadosRetorno.listaDeErros['codigo_empresa'] = 'Este campo é obrigatório'
      }

      if (this.ehPessoaFisica && !valorEhCpf(formulario.cpf_cnpj)) {
        this.dadosRetorno.listaDeErros['cpf_cnpj'] = 'O campo CPF é inválido.'
      }
      if (!this.ehPessoaFisica && !valorEhCnpj(formulario.cpf_cnpj)) {
        this.dadosRetorno.listaDeErros['cpf_cnpj'] = 'O campo CNPJ é inválido.'
      }

      const validacaoOk = Object.values(this.dadosRetorno.listaDeErros).length === 0
      return validacaoOk
    },

    tratarDadosFormularioInformacoes () {
      const dadosFormularioInformacoes = util.mapearObjetos(this.formulario.informacoes, {})
      const dadosFormularioInformacoesAdicionais = this.obterDadosFormularioInformacoesAdicionais()

      return {
        observacoes: dadosFormularioInformacoes.observacoes,
        ativo: dadosFormularioInformacoes.ativo,
        inadimplente: dadosFormularioInformacoes.inadimplente,
        logotipo: dadosFormularioInformacoes.logotipo,
        endereco_logotipo: dadosFormularioInformacoes.endereco_logotipo,
        codigo_empresa: dadosFormularioInformacoes.codigo_empresa,
        ...dadosFormularioInformacoesAdicionais
      }
    },

    tratarDadosFormulario () {
      const dadosFormularioEndereco = util.mapearObjetos(this.formulario.endereco, {})
      const dadosFormularioContato = util.mapearObjetos(this.formulario.contato, {})
      const dadosFormularioInformacoes = this.tratarDadosFormularioInformacoes()
      let dadosFormulario = {
        ...dadosFormularioInformacoes,
        ...dadosFormularioEndereco,
        ...dadosFormularioContato
      }

      dadosFormulario.data_nascimento = util.formatarData(dadosFormulario.data_nascimento, 'DD/MM/YYYY')
      // dadosFormulario.representante_legal = cadastroUtil.obterCodigoCombo({ campo: dadosFormulario.representante_legal })
      dadosFormulario.uf = cadastroUtil.obterCodigoCombo({ campo: dadosFormulario.uf })
      dadosFormulario.cep = util.apenasNumeros(dadosFormulario.cep)
      dadosFormulario.celular = util.apenasNumeros(dadosFormulario.celular)
      dadosFormulario.fone = util.apenasNumeros(dadosFormulario.fone)
      this.aplicarDocumentoNormalizadoCadastro(dadosFormulario)

      return dadosFormulario
    },

    aplicarDocumentoNormalizadoCadastro (dadosFormulario) {
      const documentoFederalInformadoNoFormulario = dadosFormulario.cpf_cnpj
      const documentoFederalNormalizadoParaPersistencia = this.normalizarDocumentoCadastro(documentoFederalInformadoNoFormulario)
      dadosFormulario.cpf_cnpj = documentoFederalNormalizadoParaPersistencia
    },

    normalizarDocumentoCadastro (valor) {
      if (this.ehPessoaFisica) {
        return cpf.normalizarCpf(valor)
      }

      return cnpj.normalizarCnpj(valor)
    },

    async executarSalvarRegistro () {
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
      try {
        const dadosFormulario = this.tratarDadosFormulario()
        const formData = this.montarObjetoDeEnvio(dadosFormulario)
        await this.ActionSalvarEscritorio(formData)

        this.resetarFlagAbasDoUsuario()
        this.limparFlagErroNoFormulario()
        this.tratarAposSalvarRegistro()
      } catch (e) {
        console.log(e)
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      }
      this.definirFlagManipulandoDados(false, '')
    },

    montarObjetoDeEnvio (dadosFormulario) {
      const formData = new FormData()
      const campos = Object.entries(dadosFormulario)
      const logotipo = ['logotipo']
      const camposIgnorados = [...logotipo, 'tipo']

      for (let [chave, valor] of campos) {
        if (!camposIgnorados.includes(chave)) {
          formData.append(chave, valor)
        }

        if (logotipo.includes(chave) && !util.valorVazio(valor)) {
          formData.append(chave, valor, valor.nome)
        }
      }
      return formData
    },

    limparCampos () {
      if (this.ehPessoaFisica) {
        this.ActionResetarDadosEmpresariaisFormularioEscritorio()
        return
      }
      this.ActionResetarDadosPessoaisFormularioEscritorio()
    },

    limparFlagErroNoFormulario () {
      this.definirFlagErroNoFormulario(false, '')
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    definirFlagErroNoFormulario (status, mensagem) {
      this.flagsDeControle.avisoDeErroNoFormulario.exibir = status
      this.flagsDeControle.avisoDeErroNoFormulario.mensagem = mensagem
    },

    mascaraTelefoneCelular (valor) {
      return mascaras.mascaraTelefoneCelular(valor)
    },

    async tratarAposSalvarRegistro () {
      this.flagsDeControle.avisoDeErroNoFormulario = util.obterDadosAlertaAposSalvarRegistro(this.dadosRetorno)
      if (this.flagsDeControle.avisoDeErroNoFormulario.exibir) {
        this.obterAbaDoComErro()
      } else {
        this.$router.push({ name: 'escritorios' }).then(() => {
          util.criarAlertaToastDeSucesso(this, 'Aviso', 'Dados salvos com sucesso.')
        })
      }
    },

    obterAbaDoComErro () {
      const erros = Object.keys(this.dadosRetorno.listaDeErros)
      const camposInformacoes = Object.keys(this.formulario.informacoes)
      const camposInformacoesPessoais = Object.keys(this.formulario.informacoes.pessoais)
      const camposInformacoesEmpresariais = Object.keys(this.formulario.informacoes.empresariais)
      const camposEndereco = Object.keys(this.formulario.endereco)
      const camposContato = Object.keys(this.formulario.contato)

      const errosInformacoes = camposInformacoes.some(campo => erros.includes(campo))
      const errosInformacoesPessoais = camposInformacoesPessoais.some(campo => erros.includes(campo))
      const errosInformacoesEmpresariais = camposInformacoesEmpresariais.some(campo => erros.includes(campo))

      this.flagAbas.endereco = camposEndereco.some(campo => erros.includes(campo))
      this.flagAbas.informacoes = errosInformacoes || errosInformacoesEmpresariais || errosInformacoesPessoais
      this.flagAbas.contato = camposContato.some(campo => erros.includes(campo))
    },

    resetarFlagAbasDoUsuario () {
      this.flagAbas = {
        informacoes: false,
        contato: false,
        endereco: false
      }
    }
  }
}
